export default __webpack_public_path__ + "images/EL.052a4b2.png";